import { supabase } from './api'

export const revalidate = 0

export async function getAllData() {
	const { data, error } = await supabase.from('studentprogresstask').select()

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function getDataWithStudent(studentId, progresstype) {
	const { data, error } = await supabase
		.from('studentprogresstask')
		.select()
		.eq('studentId', studentId)
		.eq('progresstype', progresstype)
		.order('taskenddate', { ascending: true })

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function getIdData(id) {
	const { data, error } = await supabase.from('studentprogresstask').select().eq('id', id)
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function getStudentIdData(id) {
	const { data, error } = await supabase.from('studentprogresstask').select().eq('studentId', id)
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function getStudentIdDataWithLesson(id, lesson) {
	const { data, error } = await supabase.from('studentprogresstask').select().eq('studentId', id).eq('lessonname', lesson)
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function addData(adata) {
	const { data, error } = await supabase.from('studentprogresstask').insert(adata).select()
	console.log('adata', adata, data, error)
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function updateData(id, updatedFields) {
	const { data, error } = await supabase.from('studentprogresstask').update(updatedFields).eq('id', id)

	if (error) {
		throw new Error('Failed to update data')
	}

	return data
}

export async function deleteIdData(id) {
	const { data, error } = await supabase.from('studentprogresstask').delete().eq('id', id)
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}
